import { useMemo } from 'react'
import dateFormat from 'dateformat'
import { useLockContract } from '../hooks/useContract'
import { useSingleCallResult } from '../state/multicall/hooks'

export function useRegisterList(lockAddress: string, owner?: string): any {
  const contract = useLockContract(lockAddress, false)

  const inputs = useMemo(() => [owner], [owner])
  const registerList = useSingleCallResult(contract, 'getPrincipalAddTokens', inputs).result
  const tokens = registerList?.tokens || []
  // eslint-disable-next-line no-console
  console.log(tokens, '1111')
  
  const supportNumbers = useSingleCallResult(contract, 'getPrincipalTokenLockNumbers', inputs).result
  const supportNumber = supportNumbers?.numbers || []
  const limitRes = useSingleCallResult(contract, 'limitUsersToSupport', []).result
  const limit = limitRes ? limitRes[0].toString() : 0;
  const tokensView = tokens.map((item:any, index: number) => {
    return {
      tokenAddress: item.tokenAddress,
      decimals: item.decimals.toString(),
      symbol: item.symbol,
      principal: item.principal,
      isSupport: item.isSupport,
      limit,
      num: supportNumber[index].toString(),
      time: dateFormat(item.time.toString() * 1000, 'yyyy-mm-dd HH:MM:ss'),
      timeStr: Number(item.time.toString())
    }
  })
  const tokenSort = tokensView.sort((a,b)=>{ return b.timeStr - a.timeStr})
  return tokenSort
}

export default useRegisterList
